import { SourceCard, type SourceCardProps } from '../SourceCard'

import type { FC } from 'react'

type ExternalSourceCardProps = Omit<SourceCardProps, 'ctaIcon'>

const ExternalSourceCard: FC<ExternalSourceCardProps> = ({ ...props }: ExternalSourceCardProps) => {
  return <SourceCard {...props} ctaIcon={['fal', 'external-link']} />
}

export { ExternalSourceCard }
